import { rest } from 'msw'
import { MerchantType } from 'types/types'
import mockMerchants from '../../../__mocks__/Merchants/merchants.json'

const API_URL = process.env.API_URL

const getMerchantList = rest.get<MerchantType[]>(
  `${API_URL}/api/v1/merchant`,
  async (req, res, ctx) => {
    return res(ctx.json(mockMerchants))
  }
)

export const postMerchantSuccess = rest.post<MerchantType>(
  `${API_URL}/api/v1/merchant`,
  async (_req, res, ctx) => res(ctx.json(mockMerchants[1]))
)

export const postMerchantError = rest.post(`${API_URL}/api/v1/merchant`, async (_req, res, ctx) =>
  res(ctx.status(500), ctx.json({ message: 'Internal server error' }))
)

export const putMerchantSuccess = rest.put<MerchantType>(
  `${API_URL}/api/v1/merchant/:merchantId`,
  async (_req, res, ctx) => res(ctx.json(mockMerchants[1]))
)

export const putMerchantError = rest.put(
  `${API_URL}/api/v1/merchant/:merchantId`,
  async (_req, res, ctx) => res(ctx.status(500), ctx.json({ message: 'Internal server error' }))
)

export default [getMerchantList]
